import { MeResponseSchema, type MeResponse } from '../contracts/me';
import type { RequestFn } from './client';

/**
 * Namespace `client.me` — обёртка над `GET /api/me` (Block 0 Phase 4, ADR-0014).
 *
 * Возвращает identity (`userId`, `region`) + subscription state
 * (`subscriptionStatus`, `trialStartedAt`, `expiresAt`). Не содержит
 * `name`/`phone`/`specialization` — это P-007 (региональный Postgres) +
 * требует отдельного `/api/profile` resource в Phase 9+ (B-NNN).
 *
 * `auth: true` — Authorization: Bearer ${jwt} обязателен. MSW handler
 * (Phase 4 stub) и Phase 9+ Edge Worker оба возвращают 401 без header'а.
 *
 * Симметрия с `decors`/`paint`/`handles`/`onboarding`: каждый namespace
 * валидирует response через свою Zod-схему, чтобы границы домена остались
 * чёткими и контракт-drift ловился рано (через PARSE_ERROR в client.ts).
 */
export interface MeApi {
  /** Sensitive: требует JWT (401 для гостя). */
  get(): Promise<MeResponse>;
}

export function createMeApi(request: RequestFn): MeApi {
  return {
    get: () =>
      request({
        method: 'GET',
        path: '/api/me',
        responseSchema: MeResponseSchema,
        auth: true,
      }),
  };
}
